export default __webpack_public_path__ + "static/media/schoolDate2.828169a3.png";